module.exports = __webpack_public_path__ + "static/media/dsasf-logo.f9a62a47.png";